/**
 * Used to determine if a color is SW 0074 Radiant Lilac,
 * which is used in the loneliest color promo.
 * @param color
 * @returns {boolean}
 */
export const isLoneliestColor = (color) => {
  if (!color) return false
  const { colorNumber } = color
  return String(colorNumber) === '0074'
}
